<script lang="ts" setup>
import {computed, ref, watch} from "vue";
import type {IVehicle} from "@/types/vehicle.ts";
import VehicleAcquirementListItem from '@/components/Quiz/VehicleAcquirementListItem.vue'
import ArrowLeft from "@/components/Ui/Carousel/ArrowLeft.vue";
import ArrowRight from "@/components/Ui/Carousel/ArrowRight.vue";
import BottomMarkers from "@/components/Ui/Carousel/BottomMarkers.vue";
import BodyContent from "@/components/Ui/Carousel/BodyContent.vue";

const model = defineModel<IVehicle[]>({required: true})

const currentIndex = ref(0)

const totalItems = computed(() => model.value?.length || 0)

const previousButtonIsDisabled = computed(() => currentIndex.value === 0)

const nextButtonIsDisabled = computed(() => !model.value[currentIndex.value].selected_date || currentIndex.value === totalItems.value - 1)

const completed = computed(() => model.value.map((item, i) => !!item.selected_date || !!model.value?.[i - 1]?.selected_date))

function nextSlide() {
  if (currentIndex.value < totalItems.value - 1) {
    currentIndex.value++
  }
}

function prevSlide() {
  if (currentIndex.value > 0) {
    currentIndex.value--
  }
}

function goToSlide(index: number) {
  if (index >= 0 && index < totalItems.value && completed.value?.[index]) {
    currentIndex.value = index
  }
}

watch(() => model, () => {
  const firstIndexWithoutSelectedDate = model.value.findIndex(item => !item.selected_date)
  const nextIndex = currentIndex.value + 1
  if (firstIndexWithoutSelectedDate === nextIndex) {
    nextSlide()
  }
}, {deep: true})
</script>

<template>
  <div v-if="model && model.length > 0">
    <BodyContent :totalItems="totalItems" :currentIndex="currentIndex">
      <template v-for="(vehicle, index) in model" #[`item-${index}`] :key="vehicle.vin ?? index">
        <VehicleAcquirementListItem :vehicle="vehicle" v-model="vehicle.selected_date"/>
      </template>
    </BodyContent>

    <div v-if="totalItems > 1" class="flex items-center justify-between">
      <ArrowLeft
        @click="prevSlide"
        :disabled="previousButtonIsDisabled"
      />

      <BottomMarkers
        :completed="completed"
        :currentIndex="currentIndex"
        @click="goToSlide"
      />

      <ArrowRight
        @click="nextSlide"
        :disabled="nextButtonIsDisabled"
      />
    </div>
  </div>

  <div v-else class="text-center text-gray-500">
    No vehicles to display.
  </div>
</template>
